import React, { useEffect, useRef } from "react";
import "../App.css"; // Assuming you have a CSS file to handle basic styling

const MovingChar = () => {
  const velocities = [{ dx: 1, dy: 1 }];

  // Refs to access the character
  const charRefs = [useRef(null)];

  useEffect(() => {
    let windowWidth = document.documentElement.clientWidth;
    let windowHeight = document.documentElement.clientHeight;
    let rotationAngle = 0; // Initial rotation angle

    const updateWindowSize = () => {
      windowWidth = document.documentElement.clientWidth;
      windowHeight = document.documentElement.clientHeight;
    };

    // Function to move and rotate the character
    const moveChar = (charRef, index) => {
      // Get the actual size of the character element
      const charWidth = charRef.current ? charRef.current.offsetWidth : 16;
      const charHeight = charRef.current ? charRef.current.offsetHeight : 16;

      let xPos = Math.random() * (windowWidth - charWidth);
      let yPos = Math.random() * (windowHeight - charHeight);

      const updatePosition = () => {
        xPos += velocities[index].dx;
        yPos += velocities[index].dy;
        rotationAngle += 2; // Increment the rotation angle

        // Get current size in case it changes
        const currentWidth = charRef.current
          ? charRef.current.offsetWidth
          : charWidth;
        const currentHeight = charRef.current
          ? charRef.current.offsetHeight
          : charHeight;

        // Reverse direction if the character hits the boundary
        if (xPos <= 0 || xPos >= windowWidth - currentWidth) {
          velocities[index].dx *= -1;
          xPos = Math.max(0, Math.min(xPos, windowWidth - currentWidth)); // Clamp the position
        }
        if (yPos <= 0 || yPos >= windowHeight - currentHeight) {
          velocities[index].dy *= -1;
          yPos = Math.max(0, Math.min(yPos, windowHeight - currentHeight)); // Clamp the position
        }

        // Apply the new position and rotation to the character
        if (charRef.current) {
          charRef.current.style.left = `${xPos}px`;
          charRef.current.style.top = `${yPos}px`;
          charRef.current.style.transform = `rotate(${rotationAngle}deg)`; // Apply rotation
        }

        // Use requestAnimationFrame for smooth animation
        requestAnimationFrame(updatePosition);
      };

      // Start the animation
      updatePosition();
    };

    // Move all characters
    charRefs.forEach((charRef, index) => {
      moveChar(charRef, index);
    });

    // Update window size on resize
    window.addEventListener("resize", updateWindowSize);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("resize", updateWindowSize);
    };
  }, []);

  return (
    <div
      style={{
        overflow: "hidden",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 9999,
      }}
    >
      <span ref={charRefs[0]} className="moving-char">
        ✦
      </span>
    </div>
  );
};

export default MovingChar;
